<template>
    <div id="ContactAssetDetailList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div v-if="assetId != undefined || customerId != undefined">
            <data-table-filter-config :moduleName="'contractAssetList'" ref="filterContractAsset" @cancelSelection="cancelAll" :allowSameFilter="'allow'">
            </data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'contractAssetList'" :position="'top'">
                        </custom-pagination>
                        <vue-good-table
                            ref="listContractAssetDetailTable"
                            mode="remote"
                            title="Contract Asset Detail"
                            @on-page-change="onPageChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            @on-select-all="onSelectAll"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                perPageDropdown:dropDownPerPage,
                                dropdownAllowAll: false,
                            }"
                            :select-options="{
                            enabled: contract_asset_detail_value,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                            }"
                            :search-options="{
                            enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <!-- <router-link title="Edit Contract Asset Detail" v-if="canUpdateConAsset  && props.row.closed == 0" class="fp-edit" v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:props.row.id}}"></router-link>
                                        <span v-if="props.row.closed == 0">&nbsp;|&nbsp;</span>-->
                                        <router-link v-if="assetId != undefined && canViewConAsset" title="View Contract Asset Details" class="fp-view" v-bind:to="{name: 'ContractAssetView',params:{id:props.row.id},query:{from:'asset'}}"></router-link>
                                        <router-link v-if="customerId != undefined && canViewConAsset" title="View Contract Asset Details" class="fp-view" v-bind:to="{name: 'ContractAssetView',params:{id:props.row.id},query:{from:'asset'}}"></router-link>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions">
                                <!-- <button v-if="isReturnMultipleContract" id="isReturnMultipleCotractBtn" v-on:click.prevent="returnMultipleContractList" class="btn btn-primary">Return</button>
                                <button v-if="contract_asset_detail_value" id="deleteCotractAssetDetailBtn" v-on:click.prevent="ContractAssetDetailDelete" class="btn btn-primary">Delete</button>
                                <button v-if="canAddConAsset" id="copyContractAsset" v-on:click.prevent="copyContractAsset" class="btn btn-primary">Copy</button> -->
                            </div>
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                </section>
            </div>
        </div>
        <div v-else id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Contract Asset Detail List</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                            <router-link v-if="canAddConAsset" class="btn btn-primary " v-bind:to="{name: 'ContractAssetDetailCreate'}" > <i class="fp-add"> </i> Add</router-link>
                            <a href="javascript:void(0)" class="btn btn-secondary " v-on:click="exportCheck()">
                                <i class="fp-export"></i> Export
                            </a>

                        </div>
                    </div>

                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-invoice-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getPendingConAssetList" v-on:click="getPendingConAssetList(this)" :class="'btn btn-secondary '+ pendingSelected"> Pending </button>
                                    <button type="button" id="getActiveConAssetList" v-on:click="getActiveConAssetList(this)" :class="'btn btn-secondary '+ activeSelected"> Active </button>
                                    <button type="button" id="getClosedConAssetList" v-on:click="getClosedConAssetList(this)" :class="'btn btn-secondary '+ closedSelected"> Closed </button>
                                </div>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'contractAssetList'" ref="filterContractAsset" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'contractAssetList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="listContractAssetDetailTable"
                                      mode="remote"
                                      title="Contract Asset Detail"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                        enabled: contract_asset_detail_value,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <router-link title="Edit Contract Asset Detail" v-if="canUpdateConAsset && props.row.status.toLowerCase() == 'pending' && props.row.closed == 0" class="fp-edit" v-bind:to="{name: 'ContractAssetDetailEdit',params:{id:props.row.id}}"></router-link>
                                                  <span v-if="props.row.closed == 0 && props.row.status.toLowerCase() == 'pending'">&nbsp;|&nbsp;</span>
                                                  <router-link title="View Contract Asset Details" v-if="canViewConAsset" class="fp-view" v-bind:to="{name: 'ContractAssetView',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button id="changeCustomer" v-on:click.prevent="changeCustomer" class="btn btn-primary">Change Assignee</button>
                                          <button v-if="isReturnMultipleContract" id="isReturnMultipleCotractBtn" v-on:click.prevent="returnMultipleContractList" class="btn btn-primary">Return</button>
                                          <button v-if="contract_asset_detail_value" id="deleteCotractAssetDetailBtn" v-on:click.prevent="ContractAssetDetailDelete" class="btn btn-primary">Delete</button>
                                          <button v-if="canAddConAsset" id="copyContractAsset" v-on:click.prevent="copyContractAsset" class="btn btn-primary">Copy</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ContactAssetDetailList",
        metaInfo() {
                return {
                    title: "Contract Asset List | " +process.env.COPYRIGHT_NAME
                }
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            customerId: {
                type: Number,
                required: false,
                default:undefined
            },
            assetId: {
                type: Number,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            pageKey: "_contract_asset_list_",
            isReturnMultipleContract: false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Asset',
                    field: 'vehicle_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Contract Code',
                    field: 'contract_id',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                },
                {
                    label: 'Contract Type',
                    field: 'contract_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Active","Pending","Closed"]
                    }
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Term',
                //     field: 'term',
                //     fpFieldType:"integer",
                //     filterable: true,
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Term", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            contract_asset_detail_value: false,
            loading:false,
            canAddConAsset:false,
            canUpdateConAsset:false,
            canViewConAsset:false,
            action:"list",
            batchProcess:0,
            batchNum:"",
            flag:"pending",
            pendingSelected:'',
            activeSelected:'',
            closedSelected:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_contract_asset_detail') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_contract_asset_detail') {
                            self.contract_asset_detail_value = true;
                        }
                        if (permissions[i].name == 'add_contract_asset_detail') {
                            self.canAddConAsset = true;
                            self.canUpdateConAsset = true;
                        }
                        if (permissions[i].name == 'view_contract_asset_detail') {
                            self.canViewConAsset = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            // self.getPermissions();
            // if (self.customerId == undefined && self.assetId == undefined){
                self.getPermissions();
            // }

            $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("contract_list_prev_tab");

            if ( prevSelectedTab == null ) {
                self.flag = "active";
                self.activeSelected = 'active';
                localStorage.setItem('contract_list_prev_tab', 'active');

            } else {
                if ( prevSelectedTab == 'pending' ) {

                    self.flag = "pending";
                    self.pendingSelected = 'active';

                } else if ( prevSelectedTab == 'close' ) {

                    self.flag = "close";
                    self.closedSelected = 'active';

                }else {
                    self.flag = "active";
                    self.activeSelected = 'active';
                }
            }
            if (self.assetId != undefined){
                self.flag = "all";
            }
            // setTimeout(function() {
            //     self.activeSelected = "active";
            //     self.flag = 'active';
            // },1000);

        },
        methods: {

            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listContractAssetDetailTable'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },

            returnMultipleContractList: function () {
              var self = this;
              var data = self.$refs['listContractAssetDetailTable'].selectedRows;
              var use = [];
              for (var i = 0; i < data.length; i++) {
                  use.push(self.$refs['listContractAssetDetailTable'].selectedRows[i].id);
              }
              console.log("list of IDS =", use);
              localStorage.setItem("return_contract_list",use);
              self.$router.push("/contractassetdetail/view/" + use[0]);
            },
            cancelAll: function (cancelAll) {
              this.$refs.listContractAssetDetailTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                // console.log("selection click", param.selectedRows);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                self.isReturnMultipleContract = true;
                param.selectedRows.forEach(element => {
                  if(element.status == "Active") {
                  } else {
                    self.isReturnMultipleContract = false;
                  }
                });

            },

            copyContractAsset() {

                var data = this.$refs['listContractAssetDetailTable'].selectedRows;
                if ( data.length > 1 ) {
                    alert("Please select only one record to copy contract asset.");
                } else {
                    var params = '&contractAssetId='+data[0].id+'&contractAssetStatus='+data[0].status;
                    this.$router.push({ name: 'ContractAssetDetailCreate', query: { data : btoa(params) }});
                }
            },

            loadList() {
                var self = this;
                self.loading = true;
                var data = this.$refs['listContractAssetDetailTable'].selectedRows;

                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listContractAssetDetailTable'].selectedRows[i].id)
                }
                var custId = '';
                if (self.customerId != undefined){
                    custId = self.customerId;
                }
                var assetId = '';
                if (self.assetId != undefined){
                    assetId = self.assetId;
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:use,
                    action: self.action,
                    customer_id:custId,
                    vehicle_id:assetId,
                    flag:self.flag,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/contractassetdetail/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            if ( self.action == "list" ) {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            } else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-asset-list')
                    }
                });
            },

            ContractAssetDetailDelete() {
              var self = this;
                var data = this.$refs['listContractAssetDetailTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].status != 'Pending'){
                        self.$swal('','You can remove pending contract asset only','info');
                        return;
                    }
                }
                self.$swal({
                    title: 'Are you sure that you want to delete this Contract Asset Detail?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                    //   var data = this.$refs['listContractAssetDetailTable'].selectedRows;
                    //   var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listContractAssetDetailTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteCotractAssetDetailBtn").val("Deleting ...");
                      $.ajax({
                        url: process.env.ROOT_API + "/contractassetdetail/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteCotractAssetDetailBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'contract-asset-delete')
                        }
                      });
                    } else {
                      console.log("no");
                    }
                });

            },

            getPendingConAssetList: function(){
                console.log("pending");
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getPendingConAssetList").addClass("active");
                self.pendingSelected = "active";
                self.activeSelected = "";
                self.closedSelected = "";
                localStorage.setItem('contract_list_prev_tab', 'pending');

                self.flag = 'pending';
                self.loadList();

            },
            getActiveConAssetList: function(){
                console.log("active");
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getActiveConAssetList").addClass("active");
                self.pendingSelected = "";
                self.activeSelected = "active";
                self.closedSelected = "";
                localStorage.setItem('contract_list_prev_tab', 'active');
                self.flag = 'active';
                self.loadList();

            },
            getClosedConAssetList: function(){
                console.log("closed");
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getClosedConAssetList").addClass("active");
                self.pendingSelected = "";
                self.activeSelected = "";
                self.closedSelected = "active";
                localStorage.setItem('contract_list_prev_tab', 'close');
                self.flag = 'closed';
                self.loadList();

            },
            changeCustomer:function(){
                var self = this;
                var data = this.$refs['listContractAssetDetailTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].status != 'Active'){
                        self.$swal('','Please select active contract','info');
                        return;
                    }
                    use.push(this.$refs['listContractAssetDetailTable'].selectedRows[i].id);
                }
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/contract-batch/store",
                    type: "POST",
                    data: {
                        ids:use
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.$router.push('/contractassetdetail/view/'+data.content.id+'?batch='+data.content.batch);
                        }else{
                            self.$swal('','Contract Asset Already Closed','info');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-asset-list')

                    }
                });
            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/ContractAssetDetailList.vue